"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvidenceStateAction = void 0;
var EvidenceStateAction;
(function (EvidenceStateAction) {
    EvidenceStateAction["NEW_ITEM"] = "NEW_ITEM";
    EvidenceStateAction["SHOW_ITEM"] = "SHOW_ITEM";
})(EvidenceStateAction = exports.EvidenceStateAction || (exports.EvidenceStateAction = {}));
//# sourceMappingURL=evidence-types.js.map